import React from 'react';
import { useTranslation } from 'react-i18next';

const dashAngles = [0, 45, 90, 135, 180, 225, 270, 315];
const dashCount = dashAngles.length;
const animationDurationSeconds = 0.8;

interface Props {
  className?: string;
}

export const PageSpinner: React.FC<Props> = ({
  className = 'size-[22px] text-primary',
}) => {
  const { t } = useTranslation();

  return (
    <span
      role="status"
      aria-label={t('global.loading')}
      className={`inline-block ${className}`}
    >
      <svg viewBox="0 0 24 24" className="size-full">
        {dashAngles.map((angle, index) => (
          <rect
            key={angle}
            x={11}
            y={0}
            width={2.5}
            height={6}
            rx={1}
            fill="currentColor"
            transform={`rotate(${angle} 12 12)`}
            style={{
              animation: `spinner-dash ${animationDurationSeconds}s linear infinite`,
              animationDelay: `${(-(dashCount - 1 - index) * animationDurationSeconds) / dashCount}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
};
